import { useContext, useState } from 'react';
import { getTickText, getTickVals, limitXAxisLabels } from './utils';

import Grid from '@mui/material/Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { CURRENT_METRIC_SORT_TYPE } from '../../../../pages/GHG/Charts/utils';
import BarGraph from '../../../Graphs/barGraph';
import GraphContainer from '../../../Graphs/graphContainer';
import Modal from '../../../Modals';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  graph: {
    display: 'flex',
    flex: '1 1 auto',
    minHeight: 0,
  },
  modal: {
    backgroundColor: 'white',
    height: '85%',
    width: '90%',
    maxHeight: '600px',
    maxWidth: '1400px',
  },
}));

export default ({ context }) => {
  const classes = useStyles();
  const {
    aggregate,
    downloadCallback,
    graphType,
    onLegendClick,
    loading,
    modalRange,
    onGraphUpdate,
    onLegendDoubleClick,
    onRelayout,
    range,
    setModalRange,
    setOpenControlsModal,
    setShowPlotlyLegend,
    showPlotlyLegend,
    showPlotlyLegendToggle,
    trace,
    maxY,
    googleAnalyticsTag,
    graphTitles,
    sortDirection,
    sortMetric,
  } = useContext(context);
  const [open, setOpen] = useState(false);
  const showToggle = false;

  const closeFullscreen = () => {
    setOpen(false);
    setModalRange({ x: [], y: [] });
  };

  const title = `${graphType.label} ${graphTitles[graphType.value]}`;
  const { ticktext, tickvals } = limitXAxisLabels(getTickText(trace), getTickVals(trace));

  return (
    <>
      <GraphContainer
        open={open}
        setOpen={() => setOpen(true)}
        setOpenControlsModal={setOpenControlsModal}
        setShowPlotlyLegend={setShowPlotlyLegend}
        showPlotlyLegend={showPlotlyLegend}
        showPlotlyLegendToggle={showPlotlyLegendToggle}
        title={title}
        loading={loading}
        downloadCallback={downloadCallback}
        googleAnalyticsTag={googleAnalyticsTag}
      >
        <BarGraph
          aggregate={aggregate}
          data={trace}
          layout={{
            barmode: 'stack',
            margin: { l: 50, r: 30, b: 30, t: 30 },
            xaxis: {
              range: range.x,
              automargin: true,
              tickmode: 'array',
              ticktext,
              tickvals,
              categoryorder:
                !sortMetric || sortMetric?.value === CURRENT_METRIC_SORT_TYPE.value
                  ? sortDirection.plotlyCategoryOrder
                  : 'trace',
            },
            yaxis: {
              range: range.y,
            },
            showlegend: showPlotlyLegendToggle && showPlotlyLegend,
            legend: {
              x: 1,
              xanchor: 'right',
              y: 1,
              bgcolor: 'rgba(236, 240, 245, 0.8)',
            },
          }}
          loading={loading}
          onLegendClick={onLegendClick}
          onLegendDoubleClick={onLegendDoubleClick}
          onRelayout={onRelayout}
          maxY={maxY}
        />
      </GraphContainer>
      <Modal
        handleClose={closeFullscreen}
        open={open}
        title="Chart Expansion"
        titleAlignedWithClose={true}
        styles={classes}
        disablePortal
      >
        <Grid container className={classes.root}>
          <GraphContainer
            open={open}
            setClose={closeFullscreen}
            setOpenControlsModal={setOpenControlsModal}
            showToggle={showToggle}
            title={title}
            loading={loading}
            downloadCallback={downloadCallback}
            googleAnalyticsTag={googleAnalyticsTag}
          >
            <BarGraph
              aggregate={aggregate}
              data={trace}
              layout={{
                barmode: 'stack',
                margin: { l: 50, r: 30, b: 30, t: 30 },
                xaxis: {
                  range: modalRange.x,
                  automargin: true,
                  tickmode: 'array',
                  ticktext: tickvals,
                  tickvals,
                  categoryorder: sortDirection.plotlyCategoryOrder,
                },
                yaxis: {
                  range: modalRange.y,
                },
                showlegend: showPlotlyLegendToggle && showPlotlyLegend,
              }}
              loading={loading}
              onLegendClick={onLegendClick}
              onLegendDoubleClick={onLegendDoubleClick}
              onRelayout={onRelayout}
              onUpdate={onGraphUpdate}
              maxY={maxY}
            />
          </GraphContainer>
        </Grid>
      </Modal>
    </>
  );
};
